if (!customElements.get('headcover-selects')) {
  customElements.define(
    'headcover-selects',
    class HeadcoverSelects extends HTMLElement {
      constructor() {
        super();

        this.headcoverData = null;

        this.baseVid = null;
        this.bundleId = Date.now();
        this.bundleTitle = null;
        this.clubNumber = null;
        this.image = null;
        this.notes = null;
        this.quantity = 1;
      }

      connectedCallback() {
        this.headcoverData = this.getHeadcoverData();
        this.setInitialValues();
        this.addEventListener('change', this.onChange.bind(this));

        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
          quantityInput.addEventListener('change', this.onQuantityChange.bind(this));
        }

        this.buildBundle();
      }

      /**
       * Handle changes to the form
       * @param {Event} event - The change event
       */
      onChange(event) {
        if (event.target.name === 'properties[Club number]') {
          this.clubNumber = event.target.value;
        }

        this.buildBundle();
      }

      /**
       * Handle changes to the quantity input
       * @param {Event} event - The change event
       */
      onQuantityChange(event) {
        this.quantity = event.target.value;
        this.buildBundle();
      }

      /**
       * Generate a UUID
       * @param {number} variantId - The variant ID
       * @returns {string} - The UUID
       */
      generateUuid(variantId) {
        return `${variantId}-${Math.random().toString(36).substring(2, 15)}`;
      }

      /**
       * Set the initial values from the selected club number
       */
      setInitialValues() {
        const selectedClubNumber = this.querySelector('input[name="properties[Club number]"]:checked');
        this.clubNumber = selectedClubNumber ? selectedClubNumber.value : null;

        this.baseVid = `gid://shopify/ProductVariant/${this.headcoverData.headcover.variant_id}`;
        this.bundleTitle = this.headcoverData.headcover.title;
        this.image = this.headcoverData.headcover.image;
      }

      /**
       * Set the bundle sold out state
       * @param {boolean} isSoldOut - True if the bundle is sold out, false otherwise
       */
      setBundleSoldOut(isSoldOut, text) {
        const productForm = document.querySelector('product-form');
        if (productForm) {
          productForm.toggleSubmitButton(isSoldOut, text);
        }
      }

      /**
       * Get the headcover data from the DOM
       * @returns {Object} - The headcover data
       */
      getHeadcoverData() {
        const headcoverData = this.querySelector('[data-headcover]')?.innerHTML;
        return !!headcoverData ? JSON.parse(headcoverData) : null;
      }

      /**
       * Build the bundle
       */
      buildBundle() {
        // Reset the bundle sold out state
        this.setBundleSoldOut(false, window.variantStrings.addToCart);

        // Prepare the product bundle
        const bundle = this.buildPairedComponents();

        // Update the bundle input
        const bundleString = JSON.stringify({ items: bundle });
        this.querySelector('input[name="bundle"]').value = bundleString;
      }

      /**
       * Build the paired components
       * @returns {Object[]} - The paired components
       */
      buildPairedComponents() {
        const headcover = this.headcoverData.headcover;
        const selectedPatch = this.headcoverData.patches.find((patch) => patch.label === this.clubNumber);
        const uuid = this.generateUuid(headcover.variant_id);
        const headcoverLineItem = this.bundleLineItem(headcover, uuid, true);
        const patchLineItem = this.bundleLineItem(selectedPatch, uuid);

        return [headcoverLineItem, patchLineItem];
      }

      /**
       * Prepare each bundle line item for add to cart,
       * cart transform function handles the rest
       * https://shopify.dev/docs/api/functions/reference/cart-transform
       *
       * @param {BundleComponent} component - The component to bundle
       * @param {string} uuid - To pair up head and shaft line items with each other (optional)
       * @param {boolean} baseProduct - Whether it is the base product
       * @returns {Object} - The line item object
       */
      bundleLineItem(component, uuid, baseProduct) {
        if (component.inventory_quantity <= 0) {
          this.setBundleSoldOut(true, window.variantStrings.soldOut);
        }

        const lineItem = {
          id: `${component.variant_id}`,
          quantity: this.quantity,
          properties: {
            _baseVid: this.baseVid,
            _bundleId: `${this.bundleId}-${uuid}`,
            _bundleTitle: this.bundleTitle,
            _club_uuid: uuid,
          },
        };

        if (baseProduct) {
          lineItem.properties._count = 0;
          lineItem.properties._image = this.image;
          lineItem.properties._notes = `Club@${this.clubNumber}`;
        }

        return lineItem;
      }
    },
  );
}
